
import { MASTER_DATA } from "./masterData.js";
import UploadedDocumentsDisplay from "../components/Uploadeddocumentsdisplay.jsx";
import AdditionalInfoRequestedForm from "../components/AdditionalInfoRequestedForm.jsx";

export const SHARED_SECTIONS = {

  // Uploaded Documents Section  
  Uploaded_Documents: {
    id: "uploaded_documents",
    title: "Documents",
    useCustomRenderer: true,
    customComponent: UploadedDocumentsDisplay,
    subTabs: [],
  },


  // Personal Information Section
  PERSONAL: {
    id: "personal",
    title: "Personal Information",
    subTabs: [
      {
        id: "personal_details",
        title: "Personal Details",
        fields: [
          // Basic Information
          {
            name: "surname",
            label: "Surname",
            type: "text",
            required: false,
            extract_key: "Surname",
            section: "Basic Information",
          },
          {
            name: "given_name",
            label: "Given Name",
            type: "text",
            required: false,
            extract_key: "Given Name",
            section: "Basic Information",
          },
          {
            name: "gender",
            label: "Gender",
            type: "select",
            options: MASTER_DATA.gender,
            required: false,
            extract_key: "Gender",
            default_value: "Male",
            section: "Basic Information",
          },
          {
            name: "date_of_birth",
            label: "Date of Birth",
            type: "date",
            required: false,
            extract_key: "Date of Birth",
            max: new Date().toISOString().split("T")[0],
            min: "1900-01-01",
            validations: ["notFutureDate"],
            section: "Basic Information",
          },

          // Name Change
          {
            name: "name_change",
            label: "Have you ever changed your name?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Name Changed",
            default_value: "NO",
            section: "Basic Information",
            fullWidth: true,
          },
          {
            name: "previous_surname",
            label: "Previous Surname",
            type: "text",
            required: false,
            extract_key: "Previous Surname",
            show_when: {
              field: "name_change",
              equals: "YES",
            },
            section: "Basic Information",
          },
          {
            name: "previous_given_name",
            label: "Previous Given Name",
            type: "text",
            required: false,
            extract_key: "Previous Given Name",
            show_when: {
              field: "name_change",
              equals: "YES",
            },
            section: "Basic Information",
          },

          // Birth Details
          {
            name: "town_city_of_birth",
            label: "Town/City of Birth",
            type: "text",
            required: false,
            extract_key: "Town/City of Birth",
            section: "Birth Details",
          },
          {
            name: "country_of_birth",
            label: "Country/Region of Birth",
            type: "select",
            required: false,
            extract_key: "Country of Birth",
            options_key: "country_of_birth",
            section: "Birth Details",
            searchable: true,
          },



          // Identity & Citizenship
          {
            name: "nationality",
            label: "Nationality",
            type: "select",
            required: false,
            extract_key: "Nationality",
            options_key: "nationality",
            searchable: true,
            section: "Identity & Citizenship",
          },
          {
            name: "citizenship_national_id",
            label: "Citizenship / National ID",
            type: "text",
            required: false,
            extract_key: "Citizenship/National ID",
            section: "Identity & Citizenship",
          },
          {
            name: "religion",
            label: "Religion",
            type: "select",
            options: MASTER_DATA.religion,
            required: false,
            extract_key: "Religion",
            section: "Identity & Citizenship",
          },
          {
            name: "nationality_acquisition",
            label: "Nationality Acquisition",
            type: "select",
            options: MASTER_DATA.nationality_acquisition,
            required: false,
            extract_key: "Nationality Acquisition",
            section: "Identity & Citizenship",
            default_value: "By Birth",
          },
          {
            name: "previous_nationality",
            label: "Previous Nationality",
            type: "select",
            required: false,
            options_key: "previous_nationalities",
            extract_key: "Previous Nationality",
            searchable: true,
            show_when: {
              field: "nationality_acquisition",
              equals: "By Naturalization",
            },
            section: "Identity & Citizenship",
          },

          // Education & Qualifications
          {
            name: "educational_qualification",
            label: "Educational Qualification",
            type: "select",
            options: MASTER_DATA.educational_qualification,
            required: false,
            extract_key: "Educational Qualification",
            section: "Education & Qualifications",
          },
          {
            name: "acquired_qualification",
            label: "Qualification acquired from College/University",
            type: "text",
            required: false,
            extract_key: "Acquired Qualification",
            default_value: "N/A",
            section: "Education & Qualifications",
          },

          // Additional Information
          {
            name: "identity_marks",
            label: "Visible Identification Marks",
            type: "text",
            required: false,
            extract_key: "Visible Identification Marks",
            default_value: "N/A",
            section: "Additional Information",
          },
          {
            name: "lived_2_years",
            label:
              "Have you lived for at least two years in the country where you are applying visa?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Lived 2 Years",
            default_value: "YES",
            section: "Additional Information",
            fullWidth: true,
          },
        ],
      },
      {
        id: "family",
        title: "Family",
        fields: [
          // Father's Information
          {
            name: "father_name",
            label: "Father Name",
            type: "text",
            required: false,
            extract_key: "Father Name",
            section: "Father's Information",
          },
          {
            name: "father_nationality",
            label: "Father Nationality",
            options_key: "nationality",
            type: "select",
            required: false,
            extract_key: "Father Nationality",
            searchable: true,
            section: "Father's Information",
          },
          {
            name: "father_pob",
            label: "Father Place of Birth",
            type: "text",
            required: false,
            extract_key: "Father Place of Birth",
            section: "Father's Information",
          },
          {
            name: "father_cob",
            label: "Father Country of Birth",
            type: "select",
            required: false,
            extract_key: "Father Country of Birth",
            options_key: "country_of_birth",
            section: "Father's Information",
            searchable: true,
          },

          // Mother's Information
          {
            name: "mother_name",
            label: "Mother Name",
            type: "text",
            required: false,
            extract_key: "Mother Name",
            section: "Mother's Information",
          },
          {
            name: "mother_nationality",
            label: "Mother Nationality",
            options_key: "nationality",
            type: "select",
            required: false,
            extract_key: "Mother Nationality",
            searchable: true,
            section: "Mother's Information",
          },
          {
            name: "mother_pob",
            label: "Mother Place of Birth",
            type: "text",
            required: false,
            extract_key: "Mother Place of Birth",
            section: "Mother's Information",
          },
          {
            name: "mother_cob",
            label: "Mother Country of Birth",
            type: "select",
            required: false,
            extract_key: "Mother Country of Birth",
            options_key: "country_of_birth",
            section: "Mother's Information",
            searchable: true,
          },

          // Marital Status
          {
            name: "marital_status",
            label: "Marital Status",
            type: "select",
            options: MASTER_DATA.marital_status,
            required: false,
            extract_key: "Marital Status",
            default_value: "Single",
            section: "Marital Status",
          },

          // Spouse Information
          {
            name: "spouse_name",
            label: "Spouse Name",
            type: "text",
            required: false,
            extract_key: "Spouse Name",
            show_when: {
              field: "marital_status",
              equals: "Married",
            },
            section: "Spouse Information",
          },
          {
            name: "spouse_nationality",
            label: "Spouse Nationality",
            options_key: "nationality",
            type: "select",
            required: false,
            extract_key: "Spouse Nationality",
            searchable: true,
            show_when: {
              field: "marital_status",
              equals: "Married",
            },
            section: "Spouse Information",
          },
          {
            name: "spouse_birth_place",
            label: "Spouse Place of Birth",
            type: "text",
            required: false,
            extract_key: "Spouse Birth Place",
            show_when: {
              field: "marital_status",
              equals: "Married",
            },
            section: "Spouse Information",
          },
          {
            name: "spouse_birth_country",
            label: "Spouse Country of Birth",
            type: "select",
            options_key: "country_of_birth",
            required: false,
            searchable: true,
            extract_key: "Spouse Birth Country",
            show_when: {
              field: "marital_status",
              equals: "Married",
            },
            section: "Spouse Information",
          },

          // Heritage Information
          {
            name: "pak_heritage",
            label: "Any Pakistani Heritage?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Pak Heritage",
            default_value: "NO",
            section: "Heritage Information",
            fullWidth: true,
          },
          {
            name: "pak_heritage_details",
            label: "If Yes, Details",
            type: "text",
            required: false,
            extract_key: "Pak Heritage Details",
            show_when: {
              field: "pak_heritage",
              equals: "YES",
            },
            section: "Heritage Information",
            fullWidth: true,
          },
        ],
      },
    ],
  },

  // Employment Section
  EMPLOYMENT: {
    id: "employment",
    title: "Employment Details",
    subTabs: [
      {
        id: "employment_details",
        title: "Employment Details",
        fields: [
          // Current Employment
          {
            name: "occupation",
            label: "Occupation",
            type: "text",
            required: false,
            extract_key: "Occupation",
            section: "Current Employment",
          },
          {
            name: "employer_name",
            label: "Employer Name",
            type: "text",
            required: false,
            extract_key: "Employer Name",
            section: "Current Employment",
          },
          {
            name: "designation",
            label: "Designation",
            type: "text",
            required: false,
            extract_key: "Designation",
            section: "Current Employment",
          },
          {
            name: "employer_address",
            label: "Employer Address",
            type: "text",
            required: false,
            extract_key: "Employer Address",
            section: "Current Employment",

          },
          {
            name: "employer_phone",
            label: "Employer Phone",
            type: "phone",
            required: false,
            extract_key: "Employer Phone",
            section: "Current Employment",
          },

          // Military Service
          {
            name: "military_service",
            label:
              "Are/were you in a Military/Semi-Military/Police/Security. Organization?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Military Service",
            default_value: "NO",
            section: "Military Service",
            fullWidth: true,
          },
          {
            name: "military_organization",
            label: "Organization Name",
            type: "text",
            required: false,
            extract_key: "Military Organization",
            show_when: {
              field: "military_service",
              equals: "YES",
            },
            section: "Military Service",
          },
          {
            name: "military_designation",
            label: "Designation",
            type: "text",
            required: false,
            extract_key: "Military Designation",
            show_when: {
              field: "military_service",
              equals: "YES",
            },
            section: "Military Service",
          },
          {
            name: "military_rank",
            label: "Rank",
            type: "text",
            required: false,
            extract_key: "Military Rank",
            show_when: {
              field: "military_service",
              equals: "YES",
            },
            section: "Military Service",
          },
          {
            name: "military_posting",
            label: "Posting Location",
            type: "text",
            required: false,
            extract_key: "Military Posting",
            show_when: {
              field: "military_service",
              equals: "YES",
            },
            section: "Military Service",
          },
        ],
      },
    ],
  },

  // Passport Section
  PASSPORT: {
    id: "passport",
    title: "Passport Details",
    subTabs: [
      {
        id: "passport_details",
        title: "Passport Details",
        fields: [
          // Primary Passport
          {
            name: "passport_type",
            label: "Passport Type",
            type: "select",
            options: MASTER_DATA.passport_type,
            default_value: "Ordinary Passport",
            extract_key: "Passport Type",
            section: "Primary Passport",
            required: false,
          },
          {
            name: "passport_number",
            label: "Passport Number",
            type: "text",
            extract_key: "Passport Number",
            section: "Primary Passport",
            required: false,
          },
          {
            name: "passport_place_of_issue",
            label: "Passport Place of Issue",
            type: "text",
            extract_key: "Passport Place of Issue",
            section: "Primary Passport",
            required: false,
          },
          {
            name: "passport_date_of_issue",
            label: "Passport Date of Issue",
            type: "date",
            extract_key: "Passport Date of Issue",
            max: new Date().toISOString().split("T")[0],
            section: "Primary Passport",
            required: false,
          },
          {
            name: "passport_date_of_expiry",
            label: "Passport Expiry Date",
            type: "date",
            extract_key: "Passport Date of Expiry",
            min: new Date().toISOString().split("T")[0],
            section: "Primary Passport",
            required: false,
          },

          // Other Passport
          {
            name: "has_other_passport",
            label: "Have Other Passport?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            extract_key: "Has Other Passport",
            section: "Other Passport",
            fullWidth: true,
            default_value: "NO",
            required: false,
          },
          {
            name: "other_passport_no",
            label: "Passport Number",
            type: "text",
            extract_key: "Other Passport Number",
            show_when: { field: "has_other_passport", equals: "YES" },
            section: "Other Passport",
            required: false,
          },
          {
            name: "other_passport_country",
            label: "Country/Region of Issue",
            type: "select",
            options_key: "country_of_birth",
            extract_key: "Other Passport Country",
            show_when: { field: "has_other_passport", equals: "YES" },
            section: "Other Passport",
            searchable: true,
            required: false,
          },
          {
            name: "other_passport_poi",
            label: "Passport Place of Issue",
            type: "text",
            extract_key: "Other Passport Place of Issue",
            show_when: { field: "has_other_passport", equals: "YES" },
            section: "Other Passport",
            required: false,
          },
          {
            name: "other_passport_doi",
            label: "Passport Date of Issue",
            type: "date",
            extract_key: "Other Passport Date of Issue",
            show_when: { field: "has_other_passport", equals: "YES" },
            section: "Other Passport",
            required: false,
          },
          {
            name: "other_passport_nationality",
            label: "Nationality",
            type: "select",
            options_key: "other_passport_nationality",
            extract_key: "Other Passport Nationality",
            show_when: { field: "has_other_passport", equals: "YES" },
            section: "Other Passport",
            required: false,
          },
        ],
      },
    ],
  },

  // Address Section
  ADDRESS: {
    id: "address",
    title: "Address",
    subTabs: [
      {
        id: "address",
        title: "Address",
        fields: [
          // Present Address
          {
            name: "present_address_street",
            label: "House No./Street Address",
            type: "text",
            required: false,
            extract_key: "Present Address Street",
            section: "Present Address",
            fullWidth: true,
          },
          {
            name: "present_address_city",
            label: "City",
            type: "text",
            required: false,
            extract_key: "Present Address City",
            section: "Present Address",
          },
          {
            name: "present_address_state",
            label: "State/Province/District",
            type: "text",
            required: false,
            extract_key: "Present Address State",
            section: "Present Address",
          },
          {
            name: "present_address_zip",
            label: "ZIP / Postal Code",
            type: "text",
            required: false,
            extract_key: "Present Address ZIP",
            section: "Present Address",
          },
          {
            name: "present_address_country",
            label: "Country",
            type: "select",
            options_key: "country_of_birth",
            required: false,
            extract_key: "Present Address Country",
            section: "Present Address",
            searchable: true,
          },
          {
            name: "present_phone",
            label: "Phone",
            type: "phone",
            required: false,
            extract_key: "Present Phone",
            section: "Present Address",
          },

          // Permanent Address
          {
            name: "same_as_present_address",
            label: "Same as Present Address",
            type: "checkbox",
            required: false,
            extract_key: "Same Address Checkbox",
            section: "Permanent Address",
            fullWidth: true,
          },
          {
            name: "permanent_street",
            label: "House No./Street Address",
            type: "text",
            required: false,
            extract_key: "Permanent Street",
            section: "Permanent Address",
            fullWidth: true,
          },
          {
            name: "permanent_city",
            label: "City",
            type: "text",
            required: false,
            extract_key: "Permanent City",
            section: "Permanent Address",
          },
          {
            name: "permanent_state",
            label: "State/Province/District",
            type: "text",
            required: false,
            extract_key: "Permanent State",
            section: "Permanent Address",
          },
        ],
      },
      {
        id: "references",
        title: "References",
        fields: [
          // India Reference
          {
            name: "reference_india_name",
            label: "Reference Name",
            type: "text",
            extract_key: "Reference India Name",
            section: "India Reference",
            required: false,
          },
          {
            name: "reference_india_address",
            label: "Reference Address",
            type: "text",
            extract_key: "Reference India Address",
            section: "India Reference",
            fullWidth: true,
            required: false,
          },
          {
            name: "reference_india_phone",
            label: "Reference Phone",
            type: "phone",
            extract_key: "Reference India Phone",
            section: "India Reference",
          },

          // Home Country Reference
          {
            name: "reference_home_name",
            label: "Reference Name",
            type: "text",
            extract_key: "Reference Home Name",
            section: "Home Country Reference",
            required: false,
          },
          {
            name: "reference_home_address",
            label: "Reference Address",
            type: "text",
            extract_key: "Reference Home Address",
            section: "Home Country Reference",
            fullWidth: true,
            required: false,
          },
          {
            name: "reference_home_phone",
            label: "Reference Phone",
            type: "phone",
            extract_key: "Reference Home Phone",
            section: "Home Country Reference",
            required: false,
          },
        ],
      },
    ],
  },

  // Travel Section 
  TRAVEL: {
    id: "travel",
    title: "Travel Details",
    subTabs: [
      {
        id: "travel_plans",
        title: "Travel Plans",
        fields: [
          // Port & Arrival Information
          {
            name: "port_of_arrival",
            label: "Port of Arrival",
            type: "select",
            extract_key: "Port of Arrival",
            options_key: "port_of_entry",
            section: "Port & Arrival Information",
            required: false,
          },
          {
            name: "exit_port",
            label: "Exit Port",
            type: "select",
            extract_key: "Port of Exit",
            options_key: "port_of_exit",
            section: "Port & Arrival Information",
            required: false,
          },
          {
            name: "expected_date_of_arrival",
            label: "Expected Date of Arrival",
            type: "date",
            extract_key: "Expected Date of Arrival",
            section: "Port & Arrival Information",
            required: false,
          },
          {
            name: "places_to_visit_in_india",
            label: "Places to be Visited in India",
            type: "text",
            extract_key: "Places to Visit",
            section: "Port & Arrival Information",
            fullWidth: true,
            required: false,
          },

          // Accommodation Details
          {
            name: "hotel_booking",
            label:
              "Have you booked any room in Hotel / Resort through any Tour Operator?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            default_value: "NO",
            extract_key: "Hotel Booking",
            section: "Accommodation Details",
            fullWidth: true,
          },
          {
            name: "hotel_resort_name",
            label: "Hotel / Resort Name",
            type: "text",
            extract_key: "Hotel/Resort Name",
            show_when: {
              field: "hotel_booking",
              equals: "YES",
            },
            section: "Accommodation Details",
            required: false,
          },
          {
            name: "hotel_resort_city",
            label: "Hotel / Resort City",
            type: "text",
            extract_key: "Hotel/Resort City",
            show_when: {
              field: "hotel_booking",
              equals: "YES",
            },
            section: "Accommodation Details",
            required: false,
          },

          // Previous India Visits
          {
            name: "visited_india_before",
            label: "Have you ever visited India before?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            default_value: "NO",
            extract_key: "Visited India Before",
            section: "Previous India Visits",
            fullWidth: true,
            required: false,
          },
          {
            name: "prev_stay_address",
            label: "Previous Stay Address",
            type: "text",
            extract_key: "Previous Stay Address",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            required: false,
          },
          {
            name: "cities_visited",
            label: "Previous Cities Visited",
            type: "text",
            extract_key: "Cities Visited",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            required: false,
          },
          {
            name: "last_visa_no",
            label: "Previous Visa Number",
            type: "text",
            extract_key: "Last Visa Number",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            required: false,
          },
          {
            name: "last_visa_type",
            label: "Previous Visa Type",
            type: "text",
            extract_key: "Last Visa Type",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            required: false,
          },
           {
            name: "last_visa_poi",
            label: "Previous Visa Place of Issue",
            type: "text",
            extract_key: "Last Visa Place of Issue",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            required: false,
          },
            {
            name: "last_visa_doi",
            label: "Previous Visa Date of Issue",
            type: "date",
            extract_key: "Last Visa Date of Issue",
            show_when: {
              field: "visited_india_before",
              equals: "YES",
            },
            section: "Previous India Visits",
            validations: ["notFutureDate"],
            required: false,
          },

          // Visa History
          {
            name: "permission_refused",
            label:
              "Has permission to visit or extend stay in India ever been refused?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            default_value: "NO",
            extract_key: "Permission Refused",
            section: "Visa History",
            fullWidth: true,
            required: false,
          },
          {
            name: "refusal_details",
            label: "If Yes, Details (Control No. & Date)",
            type: "text",
            extract_key: "Refusal Details",
            show_when: {
              field: "permission_refused",
              equals: "YES",
            },
            section: "Visa History",
            fullWidth: true,
            required: false,
          },

          // International Travel History
          {
            name: "countries_visited_10_years",
            label: "Countries visited in last 10 years",
            type: "text",
            extract_key: "Countries Visited in Last 10 Years",
            section: "International Travel History",
            fullWidth: true,
            required: false,
          },
          {
            name: "saarc_visit",
            label: "Visited SAARC countries (except your own) in last 3 years?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            default_value: "NO",
            extract_key: "SAARC Visit",
            section: "International Travel History",
            fullWidth: true,
            required: false,
          },


          // ✅ Replace individual SAARC fields with custom component marker
          {
            name: "saarc_visits_section",
            type: "custom",
            component: "SaarcVisitFields",
            show_when: {
              field: "saarc_visit",
              equals: "YES",
            },
            section: "International Travel History",
            fullWidth: true,
          },
        ],
      },
    ],
  },

  // Declaration Section
  DECLARATION: {
    id: "declaration",
    title: "Declaration",
    subTabs: [
      {
        id: "declaration_questions",
        title: "Declaration Questions",
        fields: [
          // Legal History
          {
            name: "arrested",
            label:
              "Have you ever been arrested/ prosecuted/ convicted by Court of Law of any country?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Arrested",
            default_value: "NO",
            section: "Legal History",
            fullWidth: true,

          },
          {
            name: "arrested_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "Arrested Details",
            show_when: {
              field: "arrested",
              equals: "YES",
            },
            section: "Legal History",
            fullWidth: true,

          },
          {
            name: "deported",
            label:
              "Have you ever been refused entry / deported by any country including India?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Deported",
            default_value: "NO",
            section: "Legal History",
            fullWidth: true,

          },
          {
            name: "deported_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "Deported Details",
            show_when: {
              field: "deported",
              equals: "YES",
            },
            section: "Legal History",
            fullWidth: true,

          },

          // Criminal Background
          {
            name: "human_trafficking",
            label:
              "Have you ever been engaged in Human trafficking/ Drug trafficking/ Child abuse/ Crime against women/ Economic offense/ Financial fraud?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Human Trafficking",
            default_value: "NO",
            section: "Criminal Background",
            fullWidth: true,

          },
          {
            name: "ht_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "HT Details",
            show_when: {
              field: "human_trafficking",
              equals: "YES",
            },
            section: "Criminal Background",
            fullWidth: true,

          },

          // Security Questions
          {
            name: "cyber_crime",
            label:
              "Have you ever been engaged in Cyber crime/ Terrorist activities/ Sabotage/ Espionage/ Genocide/ Political killing/ other act of violence?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Cyber Crime",
            default_value: "NO",
            section: "Security Questions",
            fullWidth: true,

          },
          {
            name: "cyber_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "Cyber Details",
            show_when: {
              field: "cyber_crime",
              equals: "YES",
            },
            section: "Security Questions",
            fullWidth: true,

          },
          {
            name: "extremist_views",
            label:
              "Have you ever by any means or medium, expressed views that justify or glorify terrorist violence or that may encourage others to terrorist acts or other serious criminal acts?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Extremist Views",
            default_value: "NO",
            section: "Security Questions",
            fullWidth: true,

          },
          {
            name: "extremist_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "Extremist Details",
            show_when: {
              field: "extremist_views",
              equals: "YES",
            },
            section: "Security Questions",
            fullWidth: true,

          },

          // Asylum History
          {
            name: "asylum",
            label:
              "Have you ever sought asylum (political or otherwise) in any country?",
            type: "radio",
            options: MASTER_DATA.yes_no,
            required: false,
            extract_key: "Asylum",
            default_value: "NO",
            section: "Asylum History",
            fullWidth: true,

          },
          {
            name: "asylum_details",
            label: "If yes, please give details",
            type: "textarea",
            required: false,
            extract_key: "Asylum Details",
            show_when: {
              field: "asylum",
              equals: "YES",
            },
            section: "Asylum History",
            fullWidth: true,

          },
        ],
      },
    ],
  },


  // Additional Information Requested Section
  Additional_Information_Requested: {
    id: "additional_info_requested",
    title: "Additional Information Requested",
    useCustomRenderer: true,
    customComponent: AdditionalInfoRequestedForm,
    subTabs: [],
  },
};



export const overrideSection = (baseSection, overrides) => {
  return {
    ...baseSection,
    ...overrides,
    fields: overrides.fields
      ? [...baseSection.fields, ...overrides.fields]
      : baseSection.fields,
  };
};

// Example usage:
// const customPersonal = overrideSection(SHARED_SECTIONS.PERSONAL, {
//   title: "Personal Info (Modified)",
//   fields: [{ name: "custom_field", label: "Custom", type: "text" }]
// });
